import React from "react";
import {connect} from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import WizardPopupContext, {useCustomContext, wizardPopupAction} from "../WizardPopupContext";
import {getBase64ImgOnInputChange} from "../../../../utilities";
import {errorBox_Show} from "../../../../actions/A_Popups";
import SvgIcons from "../../../Icons/SvgIcons";

const WizardPopupEditGroupUploadButton = (props) => {

  const {intl, errorBox_Show, wizardPopupGroup} = props;

  const {wizardPopupState, wizardPopupDispatch} = useCustomContext(WizardPopupContext);

  const {uploadedImageUrl, customImageUrl} = wizardPopupState;

  const onImageLoad = (e) => {
    const imageUploaded = e.target.result;
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        uploadedImageUrl: imageUploaded
      }
    })
  };

  const handleUploadChange = (event) => {
    getBase64ImgOnInputChange(event, onImageLoad, errorBox_Show, intl)
  };

  const removeThumbnailClick = () => {
    wizardPopupDispatch({
      type: wizardPopupAction,
      payload: {
        uploadedImageUrl: "",
        customImageUrl: ""
      }
    })
  };

  return (
    <div className="wizard-upload">
      <label className="wizard-upload__button"
             htmlFor="wizard-upload__button"
             style={uploadedImageUrl || customImageUrl
               ? {background: `url(${uploadedImageUrl || customImageUrl}) center center / contain no-repeat`}
               : null}>
        {uploadedImageUrl || customImageUrl
          ? null
          : <FormattedMessage id="wizard.popup.editGroupUploadButton"/>}
      </label>
      <input id="wizard-upload__button"
             type="file"
             className="wizard-upload__input"
             accept="image/png, image/jpeg, image/svg"
             onChange={handleUploadChange}/>
      {uploadedImageUrl || customImageUrl ? (
        <button className="wizard-group__icon ui-icon-gray2 ui-icon-gray2--red" onClick={removeThumbnailClick}>
          {SvgIcons.closeRed}
        </button>
      ) : null}
    </div>
  )
};

const mapStateToProps = (store) => {
  const {wizardPopupGroup} = store.wizardState;
  return {
    wizardPopupGroup,
  };
};

const mapDispatchToProps = {
  errorBox_Show
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(WizardPopupEditGroupUploadButton)
)
